import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import api from '../../api';
import { RootState } from "../../store";
import { generateAlertusTokenUrl } from "../../config";

const GENERATE_TOKEN = "generateAlertusToken";

export type TokenExpiryOption = "six months" | "one year" | "three years" | "five years" | "never";

interface IGenerateAlertusTokenPayload {
  tokenName: string;
  email: string;
  orgId: string;
  groupId: string;
  expiresAt: TokenExpiryOption;
}

interface IGenerateAlertusTokenResponse {
  token: any;
  message: any;
}

interface IGenerateAlertusTokenState {
  status: string;
  error: string|null;
  token: string | null;
  msg: string | null ;
}

const initialState: IGenerateAlertusTokenState = {
  status: Status.IDLE,
  error: null,
  token: null,
  msg: null,
};

export const generateAlertusToken = createAsyncThunk(
    GENERATE_TOKEN,
    async (payload: IGenerateAlertusTokenPayload, { rejectWithValue }) => {
      try {
        const response = await api.post<IGenerateAlertusTokenResponse>(generateAlertusTokenUrl, payload);
        return response.data;
      } catch (error) {
        throw rejectWithValue(error);
      }
    }
  );
  
  const generateAlertusTokenSlice = createSlice({
    name: GENERATE_TOKEN,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(generateAlertusToken.pending, (state) => {
          state.status = Status.PENDING;
          state.msg = null;
          state.token = null;
        })
        .addCase(generateAlertusToken.fulfilled, (state, action) => {
          state.status = Status.SUCCESS;
          state.token = action.payload.token;
          state.msg = action.payload.message;
        })
        .addCase(generateAlertusToken.rejected, (state, action) => {
          const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
          state.status = Status.FAILED;
          state.error = action?.error?.message!;
          state.msg = errorPayload?.response?.data?.error?.message || errorPayload?.response?.data?.message || 'Unknown error occurred';
        });
    },
  });
  
  export const selector = (state: RootState) => state.createAlertusToken;
  
  export default generateAlertusTokenSlice.reducer;